/**
 * HeaderLabel component calculates and displays the total of a specific column from the provided data.
 * Will format to two decimal places and add a percentage sign if the column is a percentage. Will also
 * round percentages within 0.01% to 100%. Any non numeric values will be displayed as a dash.
 *
 * @param {Object} props - The properties object.
 * @param {Array} props.data - The data array where the first element is an array of objects and the second element is the key to sum.
 *
 * @returns {JSX.Element} The JSX element displaying the formatted total.
 * @example
 * return (
 *  <HeaderLabel data={data} />
 * )
 */
const HeaderLabel = (props) => {
  if (!props.data[0]) {
    return <div>-</div>;
  }

  // Add up totals of each day (this sums all the cells in the rows below this column)
  var total = 0;
  if (typeof props.data[0] !== "string") {
    props.data[0].forEach((item) => {
      total += item[props.data[1]];
    });
  }

  // Format output, including rounding close percentages
  if (total === 0) {
    total = "-";
  } else {
    total = total.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    if (props.data[1] === "percentage") {
      if (total === "99.99") {
        total = "100.00";
      } else if (total === "0.00") {
        total = "100.00";
      }
      total = total + "%";
      if (total === "NaN%") {
        total = "-";
      }
    }
  }
  return (
    <div>
      <span>{total}</span>
    </div>
  );
};

export default HeaderLabel;
